<template>
    <div class="module-attachments">
        <div class="webinar-button-title">
            MATERIAŁY DODATKOWE
        </div>
        <div class="module-attachments-list">
            <Attachment
                v-for="(attachment, index) in attachments"
                :attachment="attachment"
                :key="index"
            />
        </div>
    </div>
</template>

<script>
export default {
    components: {
        Attachment: () => import('@/components/utils/Attachment')
    },
    props: {
        attachments: {
            type: Array,
            default: () => []
        }
    }
}
</script>

<style lang="scss" scoped>
.module-attachments {
    max-width: 50%;
    margin-left: auto;
}
.module-attachments-list {
    display: flex;
    flex-wrap: wrap;
    max-width: 100%;
}
@media (max-width: 1000px) {
    .module-content {
        flex-direction: column;
    }
    .module-attachments {
        margin-top: 1rem;
        max-width: 100%;
    }
}
</style>
